import { Component, Input, ViewChild, OnInit, OnChanges } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { SharedAuthService } from '../../../../../../shared/shared.auth.service';
import { MaintenanceService } from '../../../../../../techopsv4/services/maintenanceService';
import { MatTabGroup, MatTab, MatTabLabel, MatTabContent } from '@angular/material/tabs';
import { NgIf } from '@angular/common';
import { PropTableComponent } from '../../prop-table/prop-table.component';

@Component({
    selector: 'app-my-prop-approvals',
    templateUrl: './my-prop-approvals.component.html',
    styleUrl: './my-prop-approvals.component.css',
    imports: [MatTabGroup, MatTab, MatTabLabel, NgIf, MatTabContent, PropTableComponent]
})
export class MyPropApprovalsComponent implements OnChanges, OnInit {
  selectedIndex: any = 0;
   authorMsid: string = '';
  dataSource: any = {};
   cancelledDataSource: any[];
   rejectedDataSource: any[];
   completedDataSource: any[];
   openRequestsCount: string = '';
   cancelledRequestsCount: string = '';
   rejectedRequestsCount: string = '';
   completedRequestsCount: string = '';
   receivedData:boolean = true;
   openColumns = [
     {
       columnDef: 'Request_Id',
       header: 'Proposal ID',
       link: true,
       filter: true,
       isSort: true,
       width: '14% !important'
     },
     {
       columnDef: 'Funding_UCMG',
       header: 'Investment Name - UCMG ID',
       displayText: 'Funding_UCMG',
       link: false,
       filter: true,
       isSort: true,
       width: '30% !important'
     },
     {
       columnDef: 'Req_Status',
       header: 'Status',
       displayText: 'Req_Status',
       isSort: false,
       filter: false,
       width: '17% !important'
     },
     {
      columnDef: 'created_by',
      header: 'Requested By',
      displayText: 'created_by',
      isSort: true,
      filter: true,
      width: '17% !important'
    },
     {
       columnDef: 'created_at',
       header: 'Requested On',
       displayText: 'created_at',
       isSort: true,
      width: '15% !important'
    },
    {
      columnDef: 'Hierarchy',
      header: 'Hierarchy',
      filter: false,
      isSort: false,
      textAlign: 'center',
      width: '6% !important'
     },
     {
      columnDef: 'reset_filter',
      header: ``,
      width: '1% !important',
      textAlign: 'center',
      cell: ``,
    }
,
 
   ];
 
   approvedColumns = [
     {
       columnDef: 'Request_Id',
       header: 'Proposal ID',
       link: true,
       filter: true,
       width: "12%",
       isSort: true,
     },
     {
       columnDef: 'Funding_UCMG',
       header: 'Investment Name - UCMG ID',
       displayText: 'Funding_UCMG',
       filter: true,
       width: '24% !important',
       isSort: true,
     },
     {
       columnDef: 'created_at',
       header: 'Requested On',
       displayText: 'created_at',
       width: '12% !important',
       isSort: true,
     },
     {
      columnDef: 'created_by',
      header: 'Requested By',
      displayText: 'created_by',
      width: '16% !important',
      isSort: true,
      filter: true,
     },
     {
       columnDef: 'completed_by',
       header: 'Approved By',
       displayText: 'updated_by',  
       width: '16% !important',
       filter: true,
       isSort: true,
     },
     {
       columnDef: 'completed_at',
       header: 'Approved On',
       displayText: 'updated_at',
       lastColumn: true,
       width: '12% !important',
       isSort: true,
     },
     {
       columnDef: 'Hierarchy',
       header: 'Hierarchy',
       filter: false,
       isSort: false,
       textAlign: 'center',
       width: '6% !important',
     },
     {
       columnDef: 'reset_filter',
       header: ``,
       width: '1% !important',
       textAlign: 'center',
       cell: ``,
     }
   ];

   rejectedColumns = [
    {
      columnDef: 'Request_Id',
      header: 'Proposal ID',
      link: true,
      filter: true,
      width: "12%",
      isSort: true,
    },
    {
      columnDef: 'Funding_UCMG',
      header: 'Investment Name - UCMG ID',
      displayText: 'Funding_UCMG',
      filter: true,
      width: '24% !important',
      padding: "0 1% 0 0",
      isSort: true,
    },
    {
      columnDef: 'created_at',
      header: 'Requested On',
      displayText: 'created_at',
      width: '12% !important',
      isSort: true,
    },
    {
     columnDef: 'created_by',
     header: 'Requested By',
     displayText: 'created_by',
     width: '16% !important',
     isSort: true,
     filter: true,
    },
    {
      columnDef: 'updated_by',
      header: 'Rejected By',
      displayText: 'updated_by',  
      width: '17% !important',
      filter: true,
      isSort: true,
    },
    {
      columnDef: 'updated_at',
      header: 'Rejected On',
      displayText: 'updated_at',
      lastColumn: true,
      width: '12% !important',
      isSort: true,
    },
    {
      columnDef: 'Hierarchy',
      header: 'Hierarchy',
      filter: false,
      isSort: false,
      textAlign: 'center',
      width: '6% !important',
    },
    {
      columnDef: 'reset_filter',
      header: ``,
      width: '1% !important',
      textAlign: 'center',
      cell: ``,
    }
  ];
 
   cancelledColumns = [
     {
       columnDef: 'Request_Id',
       header: 'Proposal ID',
       link: true,
       filter: true,
       width: "14%",
       isSort: true,
     },
     {
       columnDef: 'Funding_UCMG',
       header: 'Investment Name - UCMG ID',
       displayText: 'Funding_UCMG',
       filter: true,
       width: '30% !important',
       padding: "0 1% 0 0",
       isSort: true,
     },
     {
       columnDef: 'created_at',
       header: 'Requested On',
       displayText: 'created_at',
       width: '17% !important',
       isSort: true,
     },
     {
       columnDef: 'updated_by',
       header: 'Cancelled By',
       displayText: 'updated_by',
       width: '17% !important',
       filter: true,
       isSort: true,
     },
     {
       columnDef: 'updated_at',
       header: 'Cancelled On',
       displayText: 'updated_at',
       lastColumn: true,
       width: '15% !important',
       isSort: true,
     },
     {
       columnDef: 'Hierarchy',
       header: 'Hierarchy',
       filter: false,
       isSort: false,
       textAlign: 'center',
       width: '6% !important'
     },
     {
       columnDef: 'reset_filter',
       header: ``,
       width: '1% !important',
       textAlign: 'center',
       cell: ``,
     } ];
 
 
 
     fromWorkQueue = false;
     @ViewChild('createNewRequestPopup') createNewRequestPopup;
     @Input() propApprovalTypeDetailsForCreate: any;
     countData: any;
     formatteddata: any;
     @ViewChild('requestDetailsPopup') requestDetailsPopup;
     openRequestId: any;
     fromMyRequestsCreateNew: boolean;
     restrictUserAccess: boolean = false;
     reloadOpenRequests: boolean;
     @Input() propApprovalIdsForView = [];
     @Input() propApprovalCreateRoles = [];
     @Input() inputDataSource : any;
     @Input() isUCMGOwner: boolean;
     requestStatus = '';
     tableDataSource: any[] = [];
   
     constructor(
       public toaster: ToastrService,
       public maintenanceService: MaintenanceService,
       public sharedAuthService: SharedAuthService) {
     }
     ngOnInit() {
      this.getApprovalDetails();
      console.log(this.tableDataSource, 'tableDataSource in ngOnInit');
     }
 
    ngOnChanges() {
      if (this.inputDataSource) {
        this.dataSource = this.inputDataSource;

        // Ensure arrays are defined
        this.dataSource['Open'] = this.dataSource['Open'] || [];
        this.dataSource['Approved'] = this.dataSource['Approved'] || [];
        this.dataSource['Cancelled'] = this.dataSource['Cancelled'] || [];
        this.dataSource['Rejected'] = this.dataSource['Rejected'] || [];

        this.tableDataSource = this.dataSource['Open'];
        this.openRequestsCount = this.dataSource['Open'].length.toString();
        this.cancelledRequestsCount = this.dataSource['Cancelled'].length.toString();
        this.rejectedRequestsCount = this.dataSource['Rejected'].length.toString();
        this.completedRequestsCount = this.dataSource['Approved'].length.toString();
      }
    }
 
 
 
 
   onMatChange(_event, selectedIndex) {
     let status = 'Open';
     if (selectedIndex === 0) {
         status = 'Open';
         this.tableDataSource = this.dataSource[status];
         
     } else if (selectedIndex === 1) {
         status = 'Approved';
         this.tableDataSource = this.dataSource[status];
     } else if (selectedIndex === 2) {
         status = 'Rejected';
         this.tableDataSource = this.dataSource[status];
     } else if (selectedIndex === 3) {
         status = 'Cancelled';
         this.tableDataSource = this.dataSource[status];
     }
 }

 /**
  * @description: Get UCMG Owner information from session storage
  */
 private getUCMGOwnerInfo(): any[] {
   try {
     return JSON.parse(sessionStorage.getItem('techaccessData')).UCMG_Owner || [];
   } catch (e) {
     return [];
   }
 }

 /**
  * @description: Filter data based on UCMG Owner permissions
  */
 private filterDataForUCMGOwner(response: any, statusKeys: string[]): any {
   const UCMGOwnerinfo = this.getUCMGOwnerInfo();
   const newDataSource: any = {};

   statusKeys.forEach(key => {
     newDataSource[key] = (response[key] || []).filter(
       ucmg => UCMGOwnerinfo.some(owner => owner.UCMD_ID === ucmg.UCMG_Id)
     );
   });

   return newDataSource;
 }

 /**
  * @description: Process data without UCMG Owner filtering
  */
 private processDataWithoutFiltering(response: any, statusKeys: string[]): any {
   const newDataSource: any = {};
   
   statusKeys.forEach(key => {
     newDataSource[key] = response[key] || [];
   });

   return newDataSource;
 }

 /**
  * @description: Sort open requests by priority
  */
 private sortOpenRequests(dataSource: any): void {
   dataSource['Open'] = dataSource['Open'].sort((a, b) => {
     const aPriority = a.Req_Status === 'Open' && a.Approver_Justification1 !== null ? 1 : 0;
     const bPriority = b.Req_Status === 'Open' && b.Approver_Justification1 !== null ? 1 : 0;
     return aPriority - bPriority;
   });
 }

 /**
  * @description: Update component data source and counts
  */
 private updateComponentData(dataSource: any): void {
   this.dataSource = dataSource;
   this.receivedData = true;
   this.tableDataSource = this.dataSource['Open'];
   this.openRequestsCount = this.dataSource['Open'].length.toString();
   this.cancelledRequestsCount = this.dataSource['Cancelled'].length.toString();
   this.rejectedRequestsCount = this.dataSource['Rejected'].length.toString();
   this.completedRequestsCount = this.dataSource['Approved'].length.toString();
 }

 /**
  * @description: Handle successful response from approval details API
  */
 private handleApprovalDetailsSuccess(response: any): void {
   const statusKeys = ['Open', 'Approved', 'Cancelled', 'Rejected'];
   
   let newDataSource: any;
   if (this.isUCMGOwner) {
     newDataSource = this.filterDataForUCMGOwner(response, statusKeys);
   } else {
     newDataSource = this.processDataWithoutFiltering(response, statusKeys);
   }

   this.sortOpenRequests(newDataSource);
   this.updateComponentData(newDataSource);
 }

 /**
  * @description: Handle error from approval details API
  */
 private handleApprovalDetailsError(error: any): void {
    console.error('Error fetching approval details', error);
   this.toaster.error('Error fetching request data', '', { timeOut: 5000, positionClass: 'toast-top-center' });
   this.receivedData = true;
 }

 getApprovalDetails() {
   this.maintenanceService.getMyPropApprovalData().subscribe(
     (response: any) => {
       if (response) {
         this.handleApprovalDetailsSuccess(response);
       }
     },
     (error) => {
       this.handleApprovalDetailsError(error);
     }
   );
 }

reloadData() {
  this.receivedData = false; // Indicate data is being reloaded
  this.getApprovalDetails(); // Fetch updated data
}

updateTableContent(event: any) {
  const status = event.status || 'Open'; // Default to 'Open' if no status is provided
  this.tableDataSource = this.dataSource[status] || []; // Update table data based on status
}
 
}

